import { render } from "./file-manager-layout.vue?vue&type=template&id=65b788e1"
import script from "./file-manager-layout.vue?vue&type=script&lang=js"
export * from "./file-manager-layout.vue?vue&type=script&lang=js"

import "./file-manager-layout.vue?vue&type=style&index=0&id=65b788e1&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__